var map = {
	"./404.png": 161,
	"./address_image.svg": 162,
	"./animated_ashutosh.png": 163,
	"./animated_logo.svg": 164,
	"./as.png": 165,
	"./blogs_image.svg": 166,
	"./cloud_infrastructure.svg": 167,
	"./contactMail.png": 168,
	"./coursera.png": 169,
	"./data_science.svg": 170,
	"./deeplearning_ai_logo.png": 171,
	"./developerActivity.svg": 172,
	"./education.svg": 173,
	"./experience.svg": 174,
	"./feelingProud.svg": 175,
	"./fullstack.svg": 176,
	"./giet.png": 177,
	"./github_logo.png": 178,
	"./googleAssistant.svg": 179,
	"./index.jpeg": 180,
	"./index1.jpg": 181,
	"./iot.png": 182,
	"./jsFramework.svg": 183,
	"./lagazon edutech.jpeg": 184,
	"./legato_logo.png": 185,
	"./local guide.png": 186,
	"./manOnTable.svg": 187,
	"./mclpl.jpg": 188,
	"./msa.jpeg": 189,
	"./my school.png": 190,
	"./ncc.jpeg": 191,
	"./nptel.png": 192,
	"./nss.png": 193,
	"./portfolio.gif": 194,
	"./programmer.svg": 195,
	"./projects_image - Shortcut.lnk": 196,
	"./projects_image.svg": 197,
	"./sars.png": 198,
	"./talksCardBack.svg": 199,
	"./talksCardBackAlt.svg": 200,
	"./ui_ux_design.svg": 201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;